var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outlined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.86752 2.86361C3.81311 1.91803 5.18071 1.5 6.85113 1.5H13.1474C14.8178 1.5 16.1854 1.91803 17.131 2.86361C18.0766 3.8092 18.4946 5.17681 18.4946 6.84722V13.1435C18.4946 14.8139 18.0766 16.1815 17.131 17.1271C16.1854 18.0727 14.8178 18.4907 13.1474 18.4907H2.91594C2.13789 18.4907 1.50391 17.8568 1.50391 17.0787V6.84722C1.50391 5.17681 1.92193 3.8092 2.86752 2.86361ZM3.7514 3.7475C3.12292 4.37598 2.75391 5.36949 2.75391 6.84722V17.0787C2.75391 17.1664 2.82825 17.2407 2.91594 17.2407H13.1474C14.6252 17.2407 15.6187 16.8717 16.2472 16.2432C16.8756 15.6148 17.2446 14.6213 17.2446 13.1435V6.84722C17.2446 5.36949 16.8756 4.37598 16.2472 3.7475C15.6187 3.11901 14.6252 2.75 13.1474 2.75H6.85113C5.37339 2.75 4.37989 3.11901 3.7514 3.7475Z",
    fill: "#1F2328"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4375 8.03125C5.4375 7.68607 5.71732 7.40625 6.0625 7.40625H13.9329C14.278 7.40625 14.5579 7.68607 14.5579 8.03125C14.5579 8.37643 14.278 8.65625 13.9329 8.65625H6.0625C5.71732 8.65625 5.4375 8.37643 5.4375 8.03125Z",
    fill: "#1F2328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4375 11.9688C5.4375 11.6236 5.71732 11.3438 6.0625 11.3438H11.5718C11.9169 11.3438 12.1968 11.6236 12.1968 11.9688C12.1968 12.3139 11.9169 12.5938 11.5718 12.5938H6.0625C5.71732 12.5938 5.4375 12.3139 5.4375 11.9688Z",
    fill: "#1F2328"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.46f791aabe93bb95219ec569200328b3.svg";
export { ForwardRef as ReactComponent };